
import API from '../config/api.js'

export const CustomerService = {    
  
    getAllMembersBySearch(search) {
        return API.get(`api/member/list/se=${search}`);
    },
    
    getClubMembersBySearch(search) {
        return API.get(`api/club-member/list/se=${search}`);
    },   

    getMembersByOfficeRole(search, role) {
        return API.get(`api/office-member/${role}/list/se=${search}`);
    },  


    getCustomerList(search, page) {
        return API.get(`api/customers/list/se=${search}?page=${page}`);
    },

    getClubMemberInfo(id) {
        return API.get(`api/member/info/${id}`);
    },

    getCustomerInfo(uuid) {
        return API.get(`api/customer/${uuid}/info`);
    },

    getProjects(customerId, search, page) {
        return API.get(`api/projects/${customerId}/info/se=${search}?page=${page}`);
    },

    update(id,data) {
        return API.post(`api/member/update/${id}`,data);
    },

    create(data) {
        return API.post(`api/customer/create`,data);
    },

    userUpdate(id,data) {
        return API.post(`api/user/member/update/${id}`,data);
    },

    dropMember(uuid) {
        return API.post(`api/customer/delete/${uuid}`);
    },

    getServiceProjectMembers(id, search){
        return API.get(`api/service-project/${id}/committee-members/se=${search}`);
    },

    getRegionChairManList() {
        return API.get(`api/region-chairmen/list`);
    },

    getZoneChairManList() {
        return API.get(`api/zone-chairmen/list`);
    },

    customerUpdate(id,data) {
        return API.post(`api/customer/update/${id}`,data);
    },

    getCountries(){
        return API.get(`api/customers/countries`);
    },

    getStates(country){
        return API.get(`api/customers/states/${country}`);
    },

    getProjectCustomerAddress(uuid){
        return API.get(`api/customer/project/${uuid}`);
    }

}



